"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.addAdult = addAdult;
exports.addChild = addChild;
exports.addInfant = addInfant;
exports.addLeg = addLeg;
exports.constructSearchQuery = constructSearchQuery;
exports.formatLeg = formatLeg;
exports.formatLegForRequest = formatLegForRequest;
exports.generateLeg = generateLeg;
exports.getAddPaxStateFromPaxType = getAddPaxStateFromPaxType;
exports.getDates = getDates;
exports.getDefaultDates = getDefaultDates;
exports.getDefaultLegObject = getDefaultLegObject;
exports.getDefaultMultiCityDates = getDefaultMultiCityDates;
exports.getFilterQueryFromState = getFilterQueryFromState;
exports.getMaxDate = getMaxDate;
exports.getMaximumPaxCount = getMaximumPaxCount;
exports.getMinDate = getMinDate;
exports.getMultiCitySearchBoxErrors = getMultiCitySearchBoxErrors;
exports.getRemovePaxStateFromPaxType = getRemovePaxStateFromPaxType;
exports.getReturnDate = getReturnDate;
exports.getSearchBoxErrors = getSearchBoxErrors;
exports.getSelectedDays = getSelectedDays;
exports.initFlightsSearchBoxState = initFlightsSearchBoxState;
exports.isInvalidDates = isInvalidDates;
exports.isInvalidOneWayDates = isInvalidOneWayDates;
exports.isInvalidQueryDates = isInvalidQueryDates;
exports.isValidCabin = isValidCabin;
exports.isValidDateState = isValidDateState;
exports.isValidErrorsState = isValidErrorsState;
exports.isValidLegState = isValidLegState;
exports.isValidPaxState = isValidPaxState;
exports.isValidSearchBoxState = isValidSearchBoxState;
exports.removeAdult = removeAdult;
exports.removeChild = removeChild;
exports.removeInfant = removeInfant;
exports.removeLeg = removeLeg;
exports.resetAllErrors = resetAllErrors;
exports.setNoResultsErrors = setNoResultsErrors;
exports.shouldAddMultiCityLegs = shouldAddMultiCityLegs;
exports.shouldAddTripDuration = shouldAddTripDuration;
exports.updateLegsDate = updateLegsDate;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _add_months = _interopRequireDefault(require("date-fns/add_months"));
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
var _is_valid = _interopRequireDefault(require("date-fns/is_valid"));
var _is_after = _interopRequireDefault(require("date-fns/is_after"));
var _is_past = _interopRequireDefault(require("date-fns/is_past"));
var _end_of_day = _interopRequireDefault(require("date-fns/end_of_day"));
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _is_same_day = _interopRequireDefault(require("date-fns/is_same_day"));
var _constants = require("../constants");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _range2 = _interopRequireDefault(require("lodash/range"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _filterQuery = _interopRequireDefault(require("./filter-query.utils"));
var _search = require("./search.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TRIP_DURATION_DAYS = _constants.SEARCH_BOX_CONSTANTS.TRIP_DURATION_DAYS,
  MAX_TRIP_DURATION_MONTHS = _constants.SEARCH_BOX_CONSTANTS.MAX_TRIP_DURATION_MONTHS,
  DEPARTURE_DATE_OFFSET_DAYS = _constants.SEARCH_BOX_CONSTANTS.DEPARTURE_DATE_OFFSET_DAYS,
  RETURN_DATE_OFFSET_DAYS = _constants.SEARCH_BOX_CONSTANTS.RETURN_DATE_OFFSET_DAYS;
function initFlightsSearchBoxState() {
  var _getDefaultDates = getDefaultDates(),
    departureDate = _getDefaultDates.departureDate,
    returnDate = _getDefaultDates.returnDate;
  var defaultLegs = getDefaultLegObject({
    departureDate: departureDate,
    returnDate: returnDate,
    dateFormat: _constants.SEARCH_BOX_CONSTANTS.REQUEST_DATE_FORMAT
  });
  var defaultFieldState = {
    origin: {
      isDirty: false
    },
    destination: {
      isDirty: false
    },
    departureDate: {
      isDirty: false
    },
    returnDate: {
      isDirty: false
    }
  };
  return {
    searchType: _constants.SEARCH_TYPES.ROUND_TRIP,
    legs: [defaultLegs],
    cabin: _constants.SEARCH_BOX_CONSTANTS.DEFAULT_CABIN,
    infants: _constants.SEARCH_BOX_CONSTANTS.MIN_INFANTS_COUNT,
    children: _constants.SEARCH_BOX_CONSTANTS.MIN_CHILDREN_COUNT,
    adults: _constants.SEARCH_BOX_CONSTANTS.MIN_ADULTS_COUNT,
    showRememberFiltersCheckbox: false,
    rememberFilters: false,
    fareCalendar: false,
    isModifySearch: false,
    isDomesticView: false,
    showFareCalenderCheckBox: false,
    directFlightsOnly: false,
    hasBaggageOnly: false,
    searching: false,
    flexibleDate: false,
    hasFlexibleDate: false,
    fields: [defaultFieldState, defaultFieldState, defaultFieldState, defaultFieldState, defaultFieldState, defaultFieldState]
  };
}
function getMaximumPaxCount(_ref) {
  var adults = _ref.adults,
    children = _ref.children;
  var isMaxSeats = adults + children === _constants.SEARCH_BOX_CONSTANTS.MAX_PAX_COUNT;
  return {
    adults: isMaxSeats ? adults : _constants.SEARCH_BOX_CONSTANTS.MAX_PAX_COUNT,
    children: isMaxSeats ? children : _constants.SEARCH_BOX_CONSTANTS.MAX_PAX_COUNT,
    infants: adults
  };
}
function addAdult(_ref2) {
  var adults = _ref2.adults,
    children = _ref2.children;
  var adultsCount = adults + children < _constants.SEARCH_BOX_CONSTANTS.MAX_PAX_COUNT ? adults + 1 : adults;
  return {
    adults: adultsCount
  };
}
function removeAdult(_ref3) {
  var adults = _ref3.adults,
    infants = _ref3.infants;
  var adultsCount = adults > _constants.SEARCH_BOX_CONSTANTS.MIN_ADULTS_COUNT ? adults - 1 : adults;
  return {
    adults: adultsCount,
    infants: infants > adultsCount ? adultsCount : infants
  };
}
function addChild(_ref4) {
  var adults = _ref4.adults,
    children = _ref4.children;
  var childrenCount = adults + children < _constants.SEARCH_BOX_CONSTANTS.MAX_PAX_COUNT ? children + 1 : children;
  return {
    children: childrenCount
  };
}
function removeChild(_ref5) {
  var children = _ref5.children;
  var childrenCount = children > _constants.SEARCH_BOX_CONSTANTS.MIN_CHILDREN_COUNT ? children - 1 : children;
  return {
    children: childrenCount
  };
}
function addInfant(_ref6) {
  var adults = _ref6.adults,
    infants = _ref6.infants;
  var infantCount = infants < adults ? infants + 1 : infants;
  return {
    infants: infantCount
  };
}
function removeInfant(_ref7) {
  var infants = _ref7.infants;
  var infantCount = infants > _constants.SEARCH_BOX_CONSTANTS.MIN_INFANTS_COUNT ? infants - 1 : infants;
  return {
    infants: infantCount
  };
}
function shouldAddTripDuration(_ref8) {
  var departureDate = _ref8.departureDate,
    returnDate = _ref8.returnDate;
  return !returnDate || (0, _is_after.default)(departureDate, returnDate);
}
function getDefaultDates() {
  return {
    returnDate: (0, _add_days.default)(new Date(), RETURN_DATE_OFFSET_DAYS),
    departureDate: (0, _add_days.default)(new Date(), DEPARTURE_DATE_OFFSET_DAYS)
  };
}
function getDefaultMultiCityDates(leg) {
  var _leg$departureDate, _leg$returnDate;
  var departureDate = (_leg$departureDate = leg === null || leg === void 0 ? void 0 : leg.departureDate) !== null && _leg$departureDate !== void 0 ? _leg$departureDate : new Date();
  var returnDate = (_leg$returnDate = leg === null || leg === void 0 ? void 0 : leg.returnDate) !== null && _leg$returnDate !== void 0 ? _leg$returnDate : new Date();
  return {
    returnDate: (0, _add_days.default)(new Date(returnDate), RETURN_DATE_OFFSET_DAYS),
    departureDate: (0, _add_days.default)(new Date(departureDate), DEPARTURE_DATE_OFFSET_DAYS)
  };
}
function getDates(_ref9) {
  var departureDate = _ref9.departureDate,
    returnDate = _ref9.returnDate;
  if (isInvalidDates({
    departureDate: departureDate,
    returnDate: returnDate
  })) {
    return getDefaultDates();
  }
  var newReturnDate = getReturnDate({
    departureDate: departureDate,
    returnDate: returnDate
  });
  return {
    departureDate: departureDate,
    returnDate: newReturnDate
  };
}
function getReturnDate(_ref10) {
  var departureDate = _ref10.departureDate,
    returnDate = _ref10.returnDate;
  if (shouldAddTripDuration({
    departureDate: departureDate,
    returnDate: returnDate
  })) {
    if ((0, _is_same_day.default)(departureDate, returnDate)) {
      return returnDate;
    }
    if ((0, _is_after.default)((0, _add_days.default)(departureDate, TRIP_DURATION_DAYS), getMaxDate())) {
      return getMaxDate();
    }
    return (0, _add_days.default)(departureDate, TRIP_DURATION_DAYS);
  }
  return returnDate;
}
function isInvalidDates(_ref11) {
  var departureDate = _ref11.departureDate,
    returnDate = _ref11.returnDate;
  var returnDateNull = new Date(+0).toLocaleDateString("en-US", {
    timeZone: "GMT"
  }) === new Date(returnDate).toLocaleDateString("en-US", {
    timeZone: "GMT"
  });
  var isPastReturnDate = (0, _is_past.default)((0, _end_of_day.default)(new Date(returnDate))) && !returnDateNull;
  return !(0, _is_valid.default)(new Date(departureDate)) || !(0, _is_valid.default)(new Date(returnDate)) || (0, _is_past.default)((0, _end_of_day.default)(new Date(departureDate))) || isPastReturnDate;
}
function isInvalidOneWayDates(_ref12) {
  var departureDate = _ref12.departureDate;
  return !(0, _is_valid.default)(new Date(departureDate)) || (0, _is_past.default)((0, _end_of_day.default)(new Date(departureDate)));
}
function getMinDate() {
  return new Date();
}
function getMaxDate() {
  return (0, _add_months.default)(new Date(), MAX_TRIP_DURATION_MONTHS);
}
function getSelectedDays(_ref13) {
  var departureDate = _ref13.departureDate,
    returnDate = _ref13.returnDate,
    isSingleDatePicker = _ref13.isSingleDatePicker;
  return isSingleDatePicker ? departureDate : [departureDate, {
    from: departureDate,
    to: returnDate
  }];
}
function generateLeg(lastLeg, legsCount) {
  if (legsCount === void 0) {
    legsCount = 1;
  }
  var _getDefaultMultiCityD = getDefaultMultiCityDates(lastLeg),
    departureDate = _getDefaultMultiCityD.departureDate,
    returnDate = _getDefaultMultiCityD.returnDate;
  var legRange = (0, _range2.default)(0, legsCount);
  var legObj = getDefaultLegObject({
    departureDate: departureDate,
    returnDate: returnDate,
    dateFormat: _constants.SEARCH_BOX_CONSTANTS.REQUEST_DATE_FORMAT
  });
  return legsCount === 1 ? legObj : (0, _map2.default)(legRange, function () {
    return (0, _cloneDeep2.default)(legObj);
  });
}
function addLeg(legs) {
  var lastLeg = (0, _last2.default)(legs);
  var legObj = generateLeg(lastLeg);
  if (isValidLegState(legs)) {
    return legs.length < _constants.SEARCH_BOX_CONSTANTS.MAX_LEGS_COUNT ? [].concat(legs, [legObj]) : legs;
  }
}
function removeLeg(legs, legIndex) {
  if (isValidLegState(legs)) {
    return (0, _filter2.default)(legs, function (leg, index) {
      return !(legs.length > _constants.SEARCH_BOX_CONSTANTS.MIN_LEGS_COUNT + 1 && index === legIndex);
    });
  }
}
function formatLeg(_ref14) {
  var legIndex = _ref14.legIndex,
    key = _ref14.key,
    leg = _ref14.leg,
    legState = _ref14.legState;
  var legs = [].concat(legState);
  if (leg && leg.length === 1) {
    legs[legIndex][key + "Iata"] = "";
  }
  legs[legIndex][key] = leg;
  return {
    legs: legs
  };
}
function formatLegForRequest(legFormat) {
  return [(legFormat === null || legFormat === void 0 ? void 0 : legFormat.originIata) + "-" + (legFormat === null || legFormat === void 0 ? void 0 : legFormat.destinationIata), legFormat === null || legFormat === void 0 ? void 0 : legFormat.departureDate].join("/");
}
function constructSearchQuery(_ref15) {
  var cabin = _ref15.cabin,
    adults = _ref15.adults,
    children = _ref15.children,
    infants = _ref15.infants,
    _ref15$legs = _ref15.legs,
    legs = _ref15$legs === void 0 ? [] : _ref15$legs,
    searchType = _ref15.searchType,
    directFlightsOnly = _ref15.directFlightsOnly,
    hasBaggageOnly = _ref15.hasBaggageOnly,
    flexibleDate = _ref15.flexibleDate;
  var isOneWay = searchType === _constants.SEARCH_TYPES.ONE_WAY;
  var isRoundTrip = searchType === _constants.SEARCH_TYPES.ROUND_TRIP;
  var isMultiCity = searchType === _constants.SEARCH_TYPES.MULTI_CITY;
  var firstLeg = legs[0];
  var query = [];
  isOneWay && query.push(formatLegForRequest(firstLeg));
  isRoundTrip && query.push(formatLegForRequest(firstLeg), firstLeg.returnDate);
  isMultiCity && query.push((0, _map2.default)(legs, formatLegForRequest).join("/"));
  cabin && query.push(cabin);
  adults && query.push(adults + "Adult");
  children && query.push(children + "Child");
  infants && query.push(infants + "Infant");
  isOneWay && flexibleDate && query.push("" + flexibleDate);
  var queryParams = getFilterQueryFromState({
    directFlightsOnly: directFlightsOnly,
    hasBaggageOnly: hasBaggageOnly
  });
  if (!queryParams) {
    return query.join("/");
  }
  return [query.join("/"), queryParams].join("?");
}
function getSearchBoxErrors(state, legIndex, forced) {
  var _state$legs, _state$fields, _state$fields$legInde, _state$fields$legInde2, _state$fields2, _state$fields2$legInd, _state$fields2$legInd2;
  if (legIndex === void 0) {
    legIndex = 0;
  }
  if (forced === void 0) {
    forced = false;
  }
  var isRoundTrip = (state === null || state === void 0 ? void 0 : state.searchType) === _constants.SEARCH_TYPES.ROUND_TRIP;
  var leg = state === null || state === void 0 ? void 0 : (_state$legs = state.legs) === null || _state$legs === void 0 ? void 0 : _state$legs[legIndex];
  var isOriginDirty = ((_state$fields = state.fields) === null || _state$fields === void 0 ? void 0 : (_state$fields$legInde = _state$fields[legIndex]) === null || _state$fields$legInde === void 0 ? void 0 : (_state$fields$legInde2 = _state$fields$legInde.origin) === null || _state$fields$legInde2 === void 0 ? void 0 : _state$fields$legInde2.isDirty) || forced;
  var isDestinationDirty = ((_state$fields2 = state.fields) === null || _state$fields2 === void 0 ? void 0 : (_state$fields2$legInd = _state$fields2[legIndex]) === null || _state$fields2$legInd === void 0 ? void 0 : (_state$fields2$legInd2 = _state$fields2$legInd.destination) === null || _state$fields2$legInd2 === void 0 ? void 0 : _state$fields2$legInd2.isDirty) || forced;
  var isOriginEmpty = (0, _isEmpty2.default)(leg === null || leg === void 0 ? void 0 : leg.origin);
  var isDestinationEmpty = (0, _isEmpty2.default)(leg === null || leg === void 0 ? void 0 : leg.destination);
  var isOriginIataEmpty = (0, _isEmpty2.default)(leg === null || leg === void 0 ? void 0 : leg.originIata);
  var isDestinationIataEmpty = (0, _isEmpty2.default)(leg === null || leg === void 0 ? void 0 : leg.destinationIata);
  var isDepartureDateEmpty = (0, _isEmpty2.default)(leg === null || leg === void 0 ? void 0 : leg.departureDate);
  var isReturnDateEmpty = (0, _isEmpty2.default)(leg === null || leg === void 0 ? void 0 : leg.returnDate);
  var sameOriginAndDestination = (leg === null || leg === void 0 ? void 0 : leg.originIata) === (leg === null || leg === void 0 ? void 0 : leg.destinationIata) && !isOriginIataEmpty && !isDestinationIataEmpty;
  var errors = {};
  if (isOriginDirty && isOriginEmpty && isOriginIataEmpty) {
    errors.emptyOrigin = _constants.SEARCH_BOX_ERRORS.EMPTY_ORIGIN;
  }
  if (isDestinationDirty && isDestinationEmpty && isDestinationIataEmpty) {
    errors.emptyDestination = _constants.SEARCH_BOX_ERRORS.EMPTY_DESTINATION;
  }
  if (isOriginDirty && isDestinationDirty && !isOriginEmpty && isOriginIataEmpty) {
    errors.noResultOrigin = _constants.SEARCH_BOX_ERRORS.NO_RESULT_ORIGIN;
  }
  if (isDestinationDirty && !isDestinationEmpty && isDestinationIataEmpty) {
    errors.noResultDestination = _constants.SEARCH_BOX_ERRORS.NO_RESULT_DESTINATION;
  }
  if (sameOriginAndDestination && (!isOriginEmpty || !isDestinationEmpty)) {
    errors.sameOND = _constants.SEARCH_BOX_ERRORS.SAME_OND;
  }
  if (isDepartureDateEmpty) {
    errors.emptyDepartureDate = _constants.SEARCH_BOX_ERRORS.EMPTY_DEPARTURE_DATE;
  }
  if (isRoundTrip && isReturnDateEmpty) {
    errors.emptyReturnDate = _constants.SEARCH_BOX_ERRORS.EMPTY_RETURN_DATE;
  }
  if ((state === null || state === void 0 ? void 0 : state.searchType) === _constants.SEARCH_TYPES.MULTI_CITY) {
    var _state$legs2, _state$legs3, _state$legs4, _state$legs5;
    if (legIndex > 0 && (0, _is_before.default)(new Date(leg === null || leg === void 0 ? void 0 : leg.departureDate), new Date(state === null || state === void 0 ? void 0 : (_state$legs2 = state.legs) === null || _state$legs2 === void 0 ? void 0 : (_state$legs3 = _state$legs2[legIndex - 1]) === null || _state$legs3 === void 0 ? void 0 : _state$legs3.departureDate))) {
      errors.multiCityLegDepartureGreater = _constants.SEARCH_BOX_ERRORS.MULTI_CITY_LEG_DEPARTURE_GREATER;
    }
    if (legIndex === 0 && (0, _is_after.default)(new Date(leg === null || leg === void 0 ? void 0 : leg.departureDate), new Date(state === null || state === void 0 ? void 0 : (_state$legs4 = state.legs) === null || _state$legs4 === void 0 ? void 0 : (_state$legs5 = _state$legs4[legIndex + 1]) === null || _state$legs5 === void 0 ? void 0 : _state$legs5.departureDate))) {
      errors.multiCityLegDepartureGreater = _constants.SEARCH_BOX_ERRORS.MULTI_CITY_LEG_DEPARTURE_GREATER;
    }
  }
  if (isRoundTrip && !isDepartureDateEmpty && !isReturnDateEmpty && (0, _is_before.default)(new Date(leg === null || leg === void 0 ? void 0 : leg.returnDate), new Date(leg === null || leg === void 0 ? void 0 : leg.departureDate))) {
    errors.departureGreater = _constants.SEARCH_BOX_ERRORS.DEPARTURE_GREATER;
  }
  return errors;
}
function getMultiCitySearchBoxErrors(state, forced) {
  if (forced === void 0) {
    forced = false;
  }
  var errors = {};
  var legs = state.legs;
  legs.forEach(function (leg, index) {
    var legErrors = getSearchBoxErrors(state, index, forced);
    if (!(0, _isEmpty2.default)(legErrors)) {
      var _objectSpread2;
      errors = _objectSpread(_objectSpread({}, errors), {}, (_objectSpread2 = {}, _objectSpread2["leg" + index] = legErrors, _objectSpread2));
      if (legErrors.multiCityLegDepartureGreater) {
        var _objectSpread3;
        errors = _objectSpread(_objectSpread({}, errors), {}, (_objectSpread3 = {}, _objectSpread3["leg" + (+index - 1)] = _objectSpread(_objectSpread({}, errors["leg" + (+index - 1)]), {}, {
          multiCityLegDepartureGreater: _constants.SEARCH_BOX_ERRORS.MULTI_CITY_LEG_DEPARTURE_GREATER
        }), _objectSpread3));
      }
    }
  });
  return errors;
}
function resetAllErrors(errors, direction) {
  if (!(0, _isEmpty2.default)(errors)) {
    var customErrors = _objectSpread({}, errors);
    if (direction === "origin") {
      customErrors.emptyOrigin = false;
      customErrors.sameOND = false;
      customErrors.noResultOrigin = false;
    }
    if (direction === "destination") {
      customErrors.emptyDestination = false;
      customErrors.noResultDestination = false;
    }
    return customErrors;
  }
}
function setNoResultsErrors(errors, direction) {
  var customErrors = _objectSpread({}, errors);
  if (direction === "origin") {
    customErrors.noResultOrigin = _constants.SEARCH_BOX_ERRORS.NO_RESULT_ORIGIN;
  }
  if (direction === "destination") {
    customErrors.noResultDestination = _constants.SEARCH_BOX_ERRORS.NO_RESULT_DESTINATION;
  }
  return customErrors;
}
function isValidPaxState(pax) {
  return (0, _isPlainObject2.default)(pax);
}
function getAddPaxStateFromPaxType(paxType, pax) {
  if (paxType === _constants.TRAVELLERS_TYPES_CODES_MAP.ADT) {
    return addAdult(pax);
  }
  if (paxType === _constants.TRAVELLERS_TYPES_CODES_MAP.CH) {
    return addChild(pax);
  }
  if (paxType === _constants.TRAVELLERS_TYPES_CODES_MAP.INF) {
    return addInfant(pax);
  }
}
function getRemovePaxStateFromPaxType(paxType, pax) {
  if (paxType === _constants.TRAVELLERS_TYPES_CODES_MAP.ADT) {
    return removeAdult(pax);
  }
  if (paxType === _constants.TRAVELLERS_TYPES_CODES_MAP.CH) {
    return removeChild(pax);
  }
  if (paxType === _constants.TRAVELLERS_TYPES_CODES_MAP.INF) {
    return removeInfant(pax);
  }
}
function isValidCabin(cabin) {
  return (0, _includes2.default)((0, _values2.default)(_constants.CABIN_TYPES), cabin);
}
function isValidSearchBoxState(state) {
  return (0, _isPlainObject2.default)(state);
}
function isValidLegState(legs) {
  return (0, _isObject2.default)(legs);
}
function isValidErrorsState(errors) {
  return (0, _isPlainObject2.default)(errors);
}
function isValidDateState(date) {
  return (0, _is_valid.default)(new Date(date));
}
function shouldAddMultiCityLegs(state, searchType) {
  var _state$legs6;
  return _constants.SEARCH_TYPES.MULTI_CITY === searchType && (state === null || state === void 0 ? void 0 : (_state$legs6 = state.legs) === null || _state$legs6 === void 0 ? void 0 : _state$legs6.length) === 1;
}
function updateLegsDate(_ref16) {
  var state = _ref16.state,
    legIndex = _ref16.legIndex,
    direction = _ref16.direction,
    date = _ref16.date;
  var legs = [].concat(state === null || state === void 0 ? void 0 : state.legs);
  if (!(legs !== null && legs !== void 0 && legs[legIndex]) && legs[0]) {
    legs[0][direction] = new Date();
  }
  legs[legIndex][direction] = date;
  return legs;
}
function getDefaultLegObject(_ref17) {
  var departureDate = _ref17.departureDate,
    returnDate = _ref17.returnDate,
    dateFormat = _ref17.dateFormat;
  return {
    origin: "",
    originIata: "",
    destination: "",
    destinationIata: "",
    nearbyOrigin: false,
    nearbyDestination: false,
    departureDate: (0, _format.default)(departureDate, dateFormat),
    returnDate: (0, _format.default)(returnDate, dateFormat)
  };
}
function getFilterQueryFromState(_ref18) {
  var directFlightsOnly = _ref18.directFlightsOnly,
    hasBaggageOnly = _ref18.hasBaggageOnly;
  var x = {
    hasBaggageOnly: hasBaggageOnly
  };
  if (directFlightsOnly) {
    x.stop = ["0"];
  }
  return (0, _filterQuery.default)(x);
}
function isInvalidQueryDates(query) {
  var departureDate = new Date((0, _search.getDepartureDateFromQuery)(query));
  var returnDate = new Date((0, _search.getReturnDateFromQuery)(query));
  var isRoundTrip = (0, _search.checkRoundTrip)(query);
  return isRoundTrip && isInvalidDates({
    departureDate: departureDate,
    returnDate: returnDate
  }) || isRoundTrip && (0, _is_before.default)(new Date(returnDate), new Date(departureDate)) || !isRoundTrip && isInvalidOneWayDates({
    departureDate: departureDate
  });
}